import { Box, Button, FormControl, InputLabel, TextField } from "@mui/material";
import _ from "lodash";
import React from "react";
import SimpleDialog from "../common/SimpleDialog";

type Props = {
    title: string,
    open: boolean,
    value: string,
    onChange: (value: string) => void,
    onClose: (save: boolean) => void,
}

const SaveFilterDialog = ({ value, onChange, open, onClose, title }: Props) => {
    const [error, setError] = React.useState(false);

    React.useEffect(() => {
        setError(false);
    }, [open]);

    const onSaveFilter = () => {
        setError(false);

        if (_.isEmpty(value)) {
            setError(true)
            return;
        }

        onClose(true);
    }

    return (
        <SimpleDialog title={title} open={open} onClose={() => onClose(false)} size='sm' sx={{ padding: 5, pt: 2 }} fullHeight={false}>
            <FormControl fullWidth>
                <TextField label="Filter Name" error={error} value={value} onChange={(e) => onChange(e.target.value)} />
            </FormControl>

            {error && <Box sx={{ color: 'red' }}>You must specify a filter name before saving your filters</Box>}

            <Box sx={{ pt: 10, textAlign: 'right' }}>
                <Button onClick={() => onSaveFilter()}>Save</Button>
                <Button onClick={() => onClose(false)}>Cancel</Button>
            </Box>
        </SimpleDialog>
    )
}

export { SaveFilterDialog }
export default SaveFilterDialog;